import React, { useState, useEffect } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography } from '@mui/material';
import { UploadFile, Delete, Storage } from '@mui/icons-material';
import axiosInstance from '../../axiosInstance';

const ManageExcelUpload = () => {
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        fetchFiles();
    }, []);

    const fetchFiles = async () => {
        try {
            const response = await axiosInstance.get('/api/files');
            setFiles(response.data);
        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!selectedFile) return;
        
        const formData = new FormData();
        formData.append('file', selectedFile);
        
        try {
            await axiosInstance.post('/api/upload', formData);
            setSelectedFile(null);
            fetchFiles();
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    const handleDelete = async (fileName) => {
        try {
            await axiosInstance.delete(`/api/delete/${fileName}`);
            fetchFiles();
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    };

    return (
        <div>
            <Typography variant="h5">Manage Excel Upload</Typography>
            <input type="file" onChange={handleFileChange} />
            <Button 
                variant="contained" 
                startIcon={<UploadFile />} 
                onClick={handleUpload}
                disabled={!selectedFile}
            >
                Upload
            </Button>
            
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>File Name</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {files.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={2} align="center">No files uploaded</TableCell>
                            </TableRow>
                        ) : (
                            files.map((file, index) => (
                                <TableRow key={index}>
                                    <TableCell>{file.name}</TableCell>
                                    <TableCell>
                                        <Button onClick={() => handleDelete(file.name)} startIcon={<Delete />} color="error">
                                            Delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

// Placeholder for ManageRecords
const ManageRecords = () => {
    return (
        <div>
            <Typography variant="h5">Manage Records</Typography>
            <Button variant="contained">Manage</Button>
        </div>
    );
};

// Placeholder for ManageStorage
const ManageStorage = () => {
    return (
        <div>
            <Typography variant="h5">Manage Storage</Typography>
            <Button variant="contained" startIcon={<Storage />}>Manage</Button>
        </div>
    );
};

const DataManagement = () => {
    return (
        <div>
            <ManageExcelUpload />
            <ManageRecords />
            <ManageStorage />
        </div>
    );
};

export default DataManagement;
